import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
  selector: 'eview-table-numbers-input',
  templateUrl: './table-numbers-input.component.html',
  styleUrls: ['./table-numbers-input.component.scss']
})
export class TableNumbersInputComponent implements OnInit {
  @Input() value: string[] = [];
  @Input() required: boolean = false;
  @Output() valueChange = new EventEmitter<string[]>();
  
  currentInput: string = '';
  touched: boolean = false;
  
  ngOnInit() {
    if (!this.value) {
      this.value = [];
    } else {
      // Create mutable copy if value comes from NgRx store (frozen object)
      this.value = [...this.value];
    }
  }
  
  addTableNumber() {
    const input = this.currentInput.trim();
    
    if (!input) {
      return;
    }
    
    // Pad with zeros to 6 digits
    const paddedNum = input.padStart(6, '0');
    
    if (this.value.includes(paddedNum)) {
      this.currentInput = '';
      return;
    }
    
    this.value = [...this.value, paddedNum].sort();
    this.currentInput = '';
    this.touched = true;
    this.valueChange.emit(this.value);
  }
  
  removeTableNumber(num: string) {
    this.value = [...this.value].filter(n => n !== num);
    this.touched = true;
    this.valueChange.emit(this.value);
  }
  
  onKeyPress(event: KeyboardEvent) {
    const char = event.key;
    if (!/^[0-9]$/.test(char)) {
      event.preventDefault();
    }
  }
  
  onBlur() {
    this.touched = true;
  }
  
  get hasValidationError(): boolean {
    return this.required && this.touched && this.value.length === 0;
  }
  
  markAsTouched() {
    this.touched = true;
  }
}
